export const run: ITrigger = (scenarioName, configuration) => {
  if (configuration && typeof configuration.message === 'string') {
    alert(configuration.message.replace('%SCENARIO_NAME%', scenarioName));
  } else {
    alert(`Сценарий ${scenarioName} выполнен`);
  }
  
  return Promise.resolve('OK');
};
